import $ from 'jquery';
import globalScope from 'core/globalScope';

const document = globalScope.document,
  window = globalScope.window;

function renderNative(ad, containerId) {
  const native = ad.native;
  const container = document.getElementById(containerId);

  const adTitle = container.querySelector('.js-native-ad-title'),
    // adCta = container.querySelector('.js-native-ad-cta'),
    adBody = container.querySelector('.js-native-ad-body'),
    adBody2 = container.querySelector('.js-native-ad-body2'),
    adCompany = container.querySelector('.js-native-ad-company'),
    adCta = container.querySelector('.js-native-ad-cta'),
    adImage = container.querySelectorAll('.js-native-ad-image'),
    adIcon = container.querySelector('.js-native-ad-icon');

  if (adTitle) {
    adTitle.innerHTML = native.title || '';
  }
  if (adBody) {
    adBody.innerHTML = native.body || '';
  }
  if (adCompany && native.sponsoredBy) {
    adCompany.innerHTML = native.sponsoredBy || '';
    adImage.forEach(img => img.setAttribute('title', native.sponsoredBy));
    adImage.forEach(img => img.setAttribute('alt', native.sponsoredBy));
  }
  if (adBody2) {
    adBody2.innerHTML = native.desc2 || '';
  }
  if (adCta) {
    adCta.innerHTML = native.cta || '';
  }
  if (adIcon) {
    adIcon.src = native.icon.url;
    if (native.sponsoredBy) {
      adIcon.setAttribute('alt', native.sponsoredBy);
    }
  }
  adImage.forEach(img => (img.src = native.image.url));

  const get = function(url) {
    const request = new XMLHttpRequest();
    request.open('GET', url);
    request.send(null);
  };

  const openUrl = function() {
    if (native.clickTrackers.length) {
      for (let i = 0; i < native.clickTrackers.length; i++) {
        get(native.clickTrackers[i].replace('http://', 'https://'));
      }
    }
    const newlink = document.createElement('a');
    newlink.setAttribute('href', native.clickUrl);
    newlink.setAttribute('target', '_blank');
    newlink.click();
  };

  if (native.impressionTrackers[0]) {
    for (var i = 0; i < native.impressionTrackers.length; i++) {
      get(native.impressionTrackers[i].replace('http://', 'https://'));
    }
    // container.style.display = 'block';
  }

  container.onclick = openUrl;
}

/**
 * Initialisation des pubs appnexus
 * @param pubs - Param�tres des pubs � charger
 * @param cb - Callback � appeler lorsque la pub est charg�e
 */
function appnexusInit(pubs, cb) {
  // device size
  const pageWidth = window.innerWidth || document.body.clientWidth;
  let deviceName = 'desktop';

  if (pageWidth < 740) {
    deviceName = 'smartphone';
  } else if (pageWidth >= 740 && pageWidth <= 1000) {
    deviceName = 'tablette';
  }

  //create empty apn_csa object if it doesn't exist
  window.apntag = window.apntag || {};
  //create a queue on the apn_csa object
  window.apntag.anq = window.apntag.anq || [];

  //load ast.js - async
  (function() {
    const e = document.createElement('script'),
      p = document.getElementsByTagName('head')[0];
    e.type = 'text/javascript';
    e.async = true;
    e.src = '//acdn.adnxs.com/ast/ast.js';
    p.insertBefore(e, p.firstChild);
  })();

  //push commands to loading queue, to allow for async loading
  window.apntag.anq.push(function() {
    //set global page options
    // window.apntag.debug = 1;
    if (pubs.keywords) {
      window.apntag.setPageOpts({
        member: 3273,
        disablePsa: true,
        keywords: pubs.keywords,
        auctionTimeout: 10000
      });
    }

    if (pubs.normales) {
      pubs.normales.forEach(pub => {
        window.apntag.defineTag({
          invCode: deviceName + '_' + pub.invCode,
          sizes: pub.sizes[deviceName],
          targetId: pub.targetId
        });
        window.apntag.onEvent('adLoaded', pub.targetId, function () {
          document.querySelector('#' + pub.targetId).style.display = 'block'; // show ad
          if (cb) {
            cb(pub.targetId);
          }
        });
      });
    }

    if (pubs.natives) {
      pubs.natives.forEach(pub => {
        window.apntag.defineTag({
          invCode: deviceName + '_' + pub.invCode,
          sizes: [1, 1],
          targetId: pub.targetId
        });

        window.apntag.onEvent('adAvailable', pub.targetId, function(adObj) {
          pub.template(pub.targetId);
          renderNative(adObj, pub.targetId);
          document.querySelector('#' + pub.targetId).style.display = 'block'; // show ad
          if (cb) {
            cb(pub.targetId);
          }
        });
      });
    }

    window.apntag.loadTags();
  });

  if (pubs.normales) {
    pubs.normales.forEach(function(pub) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.text = 'window.apntag.anq.push(function(){apntag.showTag("' + pub.targetId + '");});';
      $('#' + pub.targetId).append(script);
    });
  }
}

function modifiePubNative(targetId, keywords) {
  if (window.apntag.modifyTag && 'function' === typeof window.apntag.modifyTag) {
    window.apntag.modifyTag(targetId, {
      keywords: keywords
    });
    apntag.refresh([targetId]);
  }
}

export default appnexusInit;
export { modifiePubNative };
